import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import WaveUIForm_V2 from '@/shared/components/forms/WaveUIForm_V2';
import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';
import countries from '@/shared/configs/countries.json';

type BillingAddressFormProps = {
  formValues: Record<string, unknown>;
  setFormValues: (value: Record<string, unknown>) => void;
};

const BillingAddressForm: FC<BillingAddressFormProps> = ({
  formValues,
  setFormValues,
}) => {
  const { t } = useTranslation(['customers', 'common']);

  const getCountriesOptions = () => {
    return (
      countries
        .find((country) => country.code === formValues.billing_country)
        ?.provinces.map((province) => ({
          label: province.name,
          value: province.code,
        })) || []
    );
  };

  return (
    <WaveUIForm_V2
      fields={[
        {
          field_type: FieldType.Select,
          field_props: {
            name: 'billing_country',
            label: t('customers:country'),
            placeholder: t('customers:country'),
            value: formValues.billing_country as string,
            options: countries.map((country) => ({
              label: country.country,
              value: country.code,
            })),
          },
        },
        {
          field_type: FieldType.Text,
          field_props: {
            name: 'billing_address',
            label: t('customers:address'),
            placeholder: t('customers:address'),
            value: formValues.billing_address as string,
          },
        },
        {
          field_type: FieldType.Text,
          field_props: {
            name: 'billing_address2',
            label: t('customers:address2'),
            placeholder: t('customers:address2'),
            value: formValues.billing_address2 as string,
          },
        },
        {
          columns: 6,
          field_type: FieldType.Text,
          field_props: {
            name: 'billing_city',
            label: t('customers:city'),
            placeholder: t('customers:city'),
            value: formValues.billing_city as string,
          },
        },
        {
          columns: 6,
          field_type: FieldType.Select,
          field_props: {
            name: 'billing_state',
            label: t('customers:state'),
            placeholder: t('customers:state'),
            value: formValues.billing_state as string,
            options: getCountriesOptions(),
          },
        },
        {
          field_type: FieldType.Text,
          field_props: {
            name: 'billing_postcode',
            label: t('customers:postcode'),
            placeholder: t('customers:postcode'),
            value: formValues.billing_postcode as string,
          },
        },
      ]}
      getFieldsValues={(value) => {
        setFormValues({ ...formValues, ...value });
      }}
    />
  );
};

export default BillingAddressForm;
